export const SET_SELECTED_EVENTS = 'SET_SELECTED_EVENTS';
export const FETCH_EVENTS = 'FETCH_EVENTS';
export const SET_CURRENT_EVENT = 'SET_CURRENT_EVENT';
export const SET_CURRENT_EVENT_STATUS = 'SET_CURRENT_EVENT_STATUS';
export const RESET_SELECTED_EVENTS = 'RESET_SELECTED_EVENTS';
export const UPDATE_EVENT = 'UPDATE_EVENT';
